// Maps backend subscription_plans rows into Pricing card props.
// One backend plan may expand into 1-2 cards (monthly + yearly).

const fmt = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return 'R$ 0';
  return `R$ ${n.toFixed(2).replace('.', ',')}`;
};

const parseFeatures = (raw) => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.filter(Boolean);
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch {
      return [];
    }
  }
  if (typeof raw === 'object') return Object.values(raw).filter(Boolean);
  return [];
};

const CTA_LABEL = 'Baixar o app';

export const normalizePlans = (rawPlans = []) => {
  const cards = [];

  rawPlans.forEach((p) => {
    const features = parseFeatures(p.features);
    const monthly = Number(p.price_monthly) || 0;
    const yearly = Number(p.price_yearly) || 0;
    const isFree = monthly === 0 && yearly === 0;

    if (isFree) {
      cards.push({
        name: p.name,
        price: 'R$ 0',
        period: 'para sempre',
        features,
        cta: CTA_LABEL,
      });
      return;
    }

    if (monthly > 0) {
      cards.push({
        name: `${p.name} Mensal`,
        price: fmt(monthly),
        period: 'por mês',
        highlighted: true,
        features,
        cta: CTA_LABEL,
      });
    }

    if (yearly > 0) {
      cards.push({
        name: `${p.name} Anual`,
        price: fmt(yearly),
        period: 'por ano',
        features,
        cta: CTA_LABEL,
      });
    }
  });

  return cards;
};

export default normalizePlans;
